module.exports = __webpack_public_path__ + "static/media/uncheckedBox.bd2fe850.svg";